<template>
  <div class="admin_header">
    <a class="logo">
      <img src="/static/img/logo.png" alt=""> &nbsp;国家农机装备创新中心
    </a>
    <div class="header_info_control">
      <select v-model="selectLng" @change="changeLang">
        <option value="zh-CN">简体中文</option>
        <option value="en-US">英文</option>
      </select>
      <span class="header_info header_out">
        欢迎您： <a href="javascript:;" class="switch-button">{{userInfo.userName}}
          <ul>
            <li>
              <a href="javascript:;" @click="changeInfo">
                <span class="switch-role-name">信息修改</span>
              </a>
            </li>
            <li @click="dialogFormVisible=true">
              <a href="javascript:;">
                <span class="switch-role-name">重置密码</span>
              </a>
            </li>
          </ul>
        </a>
      </span>
      <span class="header_out">
        <el-button type="text" @click="loginOut">
          退出
        </el-button>
      </span>
    </div>
    <el-dialog :visible.sync="dialogFormVisible" :show-close="false" :modal-append-to-body="false" title="修改密码">
      <el-form :model="form" label-width="100px">
        <el-form-item label="原密码">
          <el-input v-model="form.oldPass" auto-complete="off" placeholder="请输入原密码" type="password" />
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="form.newPass" auto-complete="off" placeholder="请输入新密码" type="password" />
        </el-form-item>
        <el-form-item label="确认新密码">
          <el-input v-model="form.checkPassword" auto-complete="off" placeholder="请确认密码" type="password" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain @click="dialogFormVisible=false">取 消</el-button>
        <el-button plain @click="updatePassword()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="个人信息修改" :visible.sync="dialogVisable">
      <el-form ref="form" label-width="80px">
        <el-form-item label="用户名">
          <el-input v-model="userParam.userName"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名">
          <el-input v-model="userParam.realName"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="userParam.phone"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="userParam.email"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="userParam.sex">
            <el-radio :label='0'>
              男
            </el-radio>
            <el-radio :label='1'>
              女
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click=" dialogVisable= false">取 消</el-button>
        <el-button type="primary" @click="upUser">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import { localStorage, sessionStorage } from '@/common/util/storage';
import { mapMutations } from 'vuex';
import * as mutationsType from '@/store/mutations/type';
import * as loginApi from '@/api/adminApi/zh/login';
export default {
  data() {
    return {
      selectLng: 'zh-CN',
      form: {
        userId: sessionStorage.userInfo.userId
      },
      userInfo: sessionStorage.userInfo,
      userParam: {},
      dialogFormVisible: false,
      dialogVisable: false
    };
  },
  methods: {
    changeLang() {
      sessionStorage.set('lng', this.selectLng);
      this.setLng(this.selectLng);
      if (this.selectLng === 'zh-CN') {
        this.$router.push({ path: '/admin' });
      } else {
        this.$router.push({ path: '/admin/en' });
      }
    },
    updatePassword() {
      if (this.form.newPass === this.form.checkPassword) {
        loginApi.upPass(this.form).then(res => {
          localStorage.remove('token');
          this.$router.push({
            path: '/admin_login'
          });
        });
      } else {
        this.$message.error('两次密码输入不一样');
      }
    },
    changeInfo() {
      this.userParam = JSON.parse(JSON.stringify(this.userInfo));
      this.dialogVisable = true;
    },
    handleCommand(command) {
      if (command === '信息修改') {
        this.dialogVisable = true;
      }
    },
    upUser() {
      loginApi.upUser(this.userParam).then(res => {
        loginApi.getUser().then(result => {
          sessionStorage.userInfo = result.data;
          this.userInfo = result.data;
          this.dialogVisable = false;
        });
      });
    },
    loginOut() {
      localStorage.remove('token');
      sessionStorage.set('lng', null);
      this.$router.push({
        path: '/home'
      });
    },
    ...mapMutations({
      setLng: mutationsType.SET_LNG
    })
  }
};
</script>
<style lang="stylus">
@import '../../../assets/stylus/color'

.admin_header {
  height 50px
  background $color-main
  position relative
  .header_info_control {
    float right
    color white
    line-height 50px
    span {
      margin-right 10px
    }
    a {
      color #fff
      text-decoration none
      padding 10px
      border-bottom none
    }
    .header_out {
      .el-button {
        color #DCDCDC
        &:hover {
          color $color-main
        }
      }
    }
  }
  .switch-button {
    position relative
    line-height 1
    &:hover ul {
      display block
    }
    ul {
      display none
      margin 0
      padding 0
      list-style none
      position absolute
      right -30px
      top 30px
      border-radius 2px
      box-shadow 0px 2px 2px #a51b1b
      background #FFF
      z-index 9999
      overflow hidden
      li {
        border-bottom solid 1px #f3f3f3
        overflow hidden
        &:last-child {
          border-bottom none
        }
      }
      a {
        display block
        padding 10px 20px
        font-size 14px
        white-space nowrap
        border none
        &:hover {
          background-color #f3f3f3
        }
        .switch-role-name {
          display block
          font-size 14px
          color #333
          line-height 20px
        }
        .switch-org-name {
          display block
          font-size 12px
          color #999
          line-height 20px
        }
      }
    }
  }
  .logo {
    float left
    cursor pointer
    line-height 50px
    font-size 24px
    color #FFF
    margin-left 20px
    img {
      vertical-align middle
      width 50px
      height 50px
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/adminCenter/area/header.vue